import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AccountInfo } from '@azure/msal-browser';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit, OnDestroy {
  userMenuOpen = false;
  user: AccountInfo | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    public permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    this.authService.user$
      .pipe(
        filter(user => !!user),
        takeUntil(this.destroy$)
      )
      .subscribe(user => {
        this.user = user;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.user-dropdown')) {
      this.userMenuOpen = false;
    }
  }

  toggleUserMenu(event: Event): void {
    event.stopPropagation();
    this.userMenuOpen = !this.userMenuOpen;
  }

  closeAllMenus(): void {
    this.userMenuOpen = false;
  }

  login(): void {
    this.authService.loginRedirect();
  }

  logout(): void {
    this.permissionService.clearPermissions();
    this.authService.logoutRedirect();
  }

  getUserInitials(): string {
    if (!this.user?.name) return 'U';
    return this.user.name
      .split(' ')
      .map(n => n.charAt(0))
      .join('')
      .toUpperCase()
      .substring(0, 2);
  }

  getUserEmail(): string {
    if (!this.user) return '';
    const claims = (this.user as any)?.idTokenClaims;
    return (
      this.user.username ||
      claims?.email ||
      claims?.preferred_username ||
      claims?.upn ||
      this.user.localAccountId ||
      this.user.homeAccountId?.split('.')[0] ||
      this.user.name ||
      ''
    );
  }

  /** From PermissionService — resolves via server-side permission set. */
  getRoleDisplayName(): string {
    return this.permissionService.getRoleDisplayName();
  }

  /** Tailwind colour class for the role badge pill. */
  getRoleBadgeClass(): string {
    return this.permissionService.getRoleBadgeClass();
  }
}